export default __webpack_public_path__ + "static/media/sneakerswipe.58edd20e.webm";